import React, { useContext, useState } from 'react'
import { IconProp } from '@fortawesome/fontawesome'
import styled from 'styled-typed'
import { faTrash } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DiscountRule } from 'discounts/rules/discountRulesService'
import { ActionButtonA } from 'uiComponents/buttons'
import { ConfirmationDialog } from 'uiComponents/popups/confirmationDialog'
import { DiscountRulesServiceContext } from 'discounts/rules/context'
import { DiscountRulesContext } from 'discounts/rules/table/tableContext'
import { MetadataContext } from 'discounts/rules/metadataContext'
import { useTranslation } from 'translations'

const ActionCell = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`
const Icon = styled(FontAwesomeIcon)`
    cursor: pointer;
    color: ${(props) => props.theme.colors.boyBlue};
`

interface DiscountRulesTableActionsProps {
    rule: DiscountRule
}

function DiscountRulesTableActions({ rule }: DiscountRulesTableActionsProps) {
    const { t } = useTranslation()
    const discountRulesService = useContext(DiscountRulesServiceContext)
    const { reloadData } = useContext(DiscountRulesContext)
    const { accountSlug, replaceMessages } = useContext(MetadataContext)

    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false)

    const onDeleteConfirm = async () => {
        try {
            await discountRulesService.deleteDiscountRule(accountSlug, rule.id)
            reloadData()
        } catch {
            replaceMessages('delete_error', 'error', t('products.discountRules.table.deleteError'))
        } finally {
            setShowDeleteDialog(false)
        }
    }

    return (
        <ActionCell>
            {showDeleteDialog && (
                <ConfirmationDialog
                    title={t('products.discountRules.table.deleteTitle')}
                    text={t('products.discountRules.table.deleteText')}
                    buttonText={t('common.delete')}
                    destructive
                    onCancel={() => setShowDeleteDialog(false)}
                    onConfirm={onDeleteConfirm}
                />
            )}
            <ActionButtonA
                href={`/account/${accountSlug}/discounts/rules/details/${rule.id}`}
                kind="action"
                secondary
                style={{ marginRight: '1.5em' }}
            >
                {t('common.edit')}
            </ActionButtonA>
            <Icon icon={faTrash as IconProp} onClick={() => setShowDeleteDialog(true)} />
        </ActionCell>
    )
}

export default DiscountRulesTableActions
